import React, { useState, useContext } from "react";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";
import Context from "../../contexts/DefaultContext";

function SignIn() {
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const { addFlashMessage, setAlert } = useContext(Context);

  const data = {
    email: email,
    password: password,
  };

  function handleSubmit(e) {
    e.preventDefault();

    axios
      .post("/Users/authenticate", data)
      .then((res) => {
        if (
          res.data.roles[0] === "SuperAdmin" ||
          res.data.roles[0] === "Admin" ||
          res.data.roles[0] === "Employer" ||
          res.data.roles[0] === "Coach"
        ) {
          sessionStorage.setItem("FirstName", res.data.voornaam);
          sessionStorage.setItem("LastName", res.data.familienaam);
          sessionStorage.setItem("complexToken", res.data.jwtToken);
          sessionStorage.setItem("OrganisationId", res.data.organisation);
          sessionStorage.setItem("RoleName", res.data.roles[0]);
          sessionStorage.setItem("Id", res.data.id);
          sessionStorage.setItem("Email", res.data.email);
          sessionStorage.setItem("LockedOut", res.data.lockoutEnabled);

          if (res.data.lockoutEnabled) {
            addFlashMessage("Uw account is gepauzeerd, u kan gegevens bekijken, maar niets aanmaken, updaten of verwijderen.", "warning");
            setAlert(true);

            const timer = setTimeout(() => {
              goToStart();
              const timer2 = setTimeout(() => {
                refreshPage();
              }, 2000); //Refresh Page (so the header updates) after 2 more seconds
            }, 2000); //Go to Start after 2 seconds
          } else {
            goToStart();
            refreshPage();
          }

          
          
        } else {
          addFlashMessage("Je account is nog niet goedgekeurd!", "danger");
          setAlert(true);
        }
      })
      .catch((error) => {
        if (error.response !== undefined) {
          if (error.response.status === 400) {
            addFlashMessage("Email en/of wachtwoord is niet correct!", "danger");
            setAlert(true);
          } else {
            addFlashMessage(
              "Er is iets fout gelopen. Probeer later opnieuw!",
              "danger"
            );
            setAlert(true);
          }
        } else {
          addFlashMessage(
            "Er is iets fout gelopen met de server. Probeer later opnieuw!",
            "danger"
          );
          setAlert(true);
        }
      });
  }

  const history = useHistory();
  function goToStart() {
    history.push("/HomePage");
  }

  const refreshPage = () => {
    window.location.reload();
  };

  const fieldStyle = {
    width: "100%",
    padding: "0.55rem 0.75rem",
    borderRadius: "6px",
    border: "1px solid rgba(255,255,255,0.3)",
    backgroundColor: "rgba(255,255,255,0.95)",
    fontSize: "1rem",
    color: "#333",
    boxSizing: "border-box",
  };

  const labelStyle = {
    color: "white",
    fontWeight: "600",
    marginBottom: "0.3rem",
    display: "block",
    fontSize: "0.9rem",
    letterSpacing: "0.02em",
  };

  return (
    <div className="App">
      <div className="outer">
        <div className="inner" style={{ maxWidth: "420px", width: "100%" }}>
          <form onSubmit={handleSubmit} style={{ padding: "0 0.5rem" }}>

            <div style={{ marginBottom: "1.5rem" }}>
              <p style={{ color: "white", fontSize: "1.5rem", fontWeight: "700", margin: 0 }}>
                Log in
              </p>
              <p style={{ color: "rgba(255,255,255,0.7)", fontSize: "0.9rem", margin: "0.25rem 0 0" }}>
                Nog geen account?{" "}
                <Link to="/sign-up" style={{ color: "white", fontWeight: "600" }}>
                  Registreer
                </Link>
              </p>
            </div>

            <div style={{ marginBottom: "1.1rem" }}>
              <label style={labelStyle}>E-mailadres</label>
              <input
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                required
                style={fieldStyle}
                placeholder="naam@organisatie.be"
                autoComplete="email"
              />
            </div>

            <div style={{ marginBottom: "1.1rem" }}>
              <label style={labelStyle}>Wachtwoord</label>
              <input
                onChange={(e) => setPassword(e.target.value)}
                type="password"
                required
                style={fieldStyle}
                placeholder="Wachtwoord"
                autoComplete="current-password"
              />
            </div>

            <button
              type="submit"
              style={{
                width: "100%",
                marginTop: "0.5rem",
                padding: "0.75rem",
                backgroundColor: "white",
                color: "#2d5971",
                border: "none",
                borderRadius: "6px",
                fontSize: "1rem",
                fontWeight: "700",
                cursor: "pointer",
                letterSpacing: "0.03em",
              }}
            >
              Log in
            </button>

          </form>
        </div>
      </div>
    </div>
  );
}

export default SignIn;
